(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart-drawer"]) return;
  try {
    
  (() => {
    const forms = document.querySelectorAll('[data-tle-cart-promo-form]');

    forms.forEach((form) => {
      if (form.dataset.tleCartPromoReady === 'true') return;

      form.dataset.tleCartPromoReady = 'true';

      form.addEventListener('submit', async (event) => {
        event.preventDefault();

        const root = form.closest('[data-tle-cart-promo]');
        const input = form.querySelector('[data-tle-cart-promo-input]');
        const error = root?.querySelector('[data-tle-cart-promo-error]');
        const button = form.querySelector('button[type="submit"]');
        const code = input?.value.trim();

        if (!code) return;

        if (error) {
          error.hidden = true;
          error.textContent = '';
        }

        if (button) button.disabled = true;

        try {
          const response = await fetch(window.Theme?.routes?.cart_update_url || '/cart/update.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/json',
            },
            body: JSON.stringify({ discount: code }),
          });

          if (!response.ok) throw new Error('Discount request failed');

          window.location.reload();
        } catch (discountError) {
          if (error) {
            error.textContent = 'Enter the code again before checkout.';
            error.hidden = false;
          }
        } finally {
          if (button) button.disabled = false;
        }
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
